module.exports = fox._r("components/valentines-gifts-popup/fonts/arvo-bold-webfont.woff", __webpack_public_path__ + "_/_/_/root/components/valentines-gifts-popup/fonts/3SgqS77.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/valentines-gifts-popup/fonts/arvo-bold-webfont.woff
// module id = 686
// module chunks = 4